import extendNode from '../extendNode.mjs'
import useCategoryNode from '../_CATEGORY/useCategoryNode.jsx'
import meta from './metaBrfOverview.mjs'

export default () => {
    const CategoryNode = useCategoryNode()

    return extendNode(CategoryNode, {
        ...meta,

        canMountType(map, node, type) {
            return /^(CAT|AR)$/.test(type)
        },

        menuItemsInsertCommon(map, node) {
            return [
                {type: 'CAT'},
                {type: 'AR'},
            ]
        },

        canWriteTree(map) {
            const data = map.root.data;

            return ['DRAFT', 'PRE_APPROVAL_REJECTED', 'ACCESS_APPROVAL_REJECTED'].includes(data.brfStsCode)
        },

        // menuItemsInsertProduct(map, node) {
        //     return [
        //         {type: 'DE'},
        //         {type: 'DE_1'},
        //     ]
        // },
    })
}
